const translations = {
    'tabs.buildings': 'Buildings',
    'tabs.buildings.core': 'Core',
    'tabs.buildings.food': 'Food',
    'tabs.buildings.industry': 'Industry',
    'tabs.buildings.mining': 'Mining',
    'tabs.buildings.craft': 'Craft',
    'tabs.buildings.support': 'Support',
    'tabs.forest': 'Forest',
    'tabs.jobs': 'Jobs',
    'tabs.jobs.core': 'Core',
    'tabs.jobs.food': 'Food',
    'tabs.jobs.industry': 'Industry',
    'tabs.jobs.mining': 'Mining',
    'tabs.jobs.craft': 'Craft',
    'tabs.jobs.support': 'Support',
    'tabs.log': 'Log',
    'tabs.nature': 'Nature',
    'tabs.production': 'Production',
    'tabs.population': 'Population',
    'tabs.storage': 'Storage',
    'tabs.tools': 'Tools',
    'tabs.wildlife': 'Wildlife',
    'tabs.assistants': 'Assistants',
    'tabs.assistants.title': 'Assistants',
};

export default translations;
